import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ClientService } from "../../../shared/client/client.service";
import { DeliveryDetailsService } from "./delivery-details.service";

@Injectable({
    providedIn: 'root'
})
export class ListCabResolver {
    constructor(
        private clientService: ClientService,
        private deliveryService: DeliveryDetailsService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Array<Object>> {
        return this.deliveryService.getDetails(this.clientService.currentClient$.getValue(), new Date(route.params['date']), route.params['code_article']);
    }

}
